import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { Dropdown } from '../../components/Dropdown'
import { fetchListingCategories } from '../../states/schools/listingCategories/actions'

const StyledSchoolListingCategoryDropdown = styled.div``

const SchoolListingCategoryDropdown = (props) => {
  const dispatch = useDispatch()
  const categories = useSelector(
    ({ schoolListingCategories }) => schoolListingCategories.list
  )
  useEffect(() => {
    dispatch(fetchListingCategories())
  }, [dispatch])
  console.log('categories', categories)
  return (
    <StyledSchoolListingCategoryDropdown>
      <Dropdown
        isMulti
        items={categories.map((c) => ({
          text: c.name,
          value: c.id,
        }))}
        {...props}
      />
    </StyledSchoolListingCategoryDropdown>
  )
}

export { SchoolListingCategoryDropdown }
